import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { OctopusPurpleLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

export const DefaultIconButton: React.FC = () => (
  <DropdownMenu.Button preventClose id="default" reversed title="Default">
    <OctopusPurpleLogo />
  </DropdownMenu.Button>
)
